<template>
  <option :value="value" ><slot /></option>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Object],
      required: false
    },
    selected: {
      type: [String, Number],
      required: false
    },
  },
  computed: {
    isSelected: function isSelected() {
      return this.value === this.selected;
    },

    theValue() {
      return JSON.stringify(this.value);
    }
  },
}
</script>
